import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDataService } from '../../../../core/services/modal-data.service';
import { ModalService } from '../../../../core/services/modal.service';

interface FamilyMemberModalData {
  passportNumber?: string;
}

@Component({
  selector: 'app-family-member-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './family-member-modal.component.html',
})
export class FamilyMemberModalComponent {
  passportNumber = '';
  form = { firstName: '', lastName: '', relationship: '' };

  constructor(private modalService: ModalService) {
    const data = ModalDataService.getData() as FamilyMemberModalData | undefined;
    this.passportNumber = data?.passportNumber ?? '';
  }

  isValid(): boolean {
    return Boolean(
      this.form.firstName.trim() &&
        this.form.lastName.trim() &&
        this.form.relationship.trim(),
    );
  }

  confirm(): void {
    if (!this.isValid()) return;
    this.modalService.emitEvent({
      type: 'familyMemberAdded',
      data: {
        firstName: this.form.firstName.trim(),
        lastName: this.form.lastName.trim(),
        relationship: this.form.relationship.trim(),
        passportNumber: this.passportNumber,
      },
    });
    this.modalService.closeAll();
  }

  cancel(): void {
    this.modalService.closeAll();
  }
}
